import { usePlatformUpdate } from '@reapitform/hooks'

export const useDefaultsDocumentDelete = (id: string) => {
  const path: string = `/api/Organization/DefaultAttachment/${id}`

  const [deleteDocument, isLoading, returnData, isSuccess, isError] = usePlatformUpdate<undefined, any>({
    path: path,
    method: 'DELETE',
    headers: {},
    errorMessage: 'Failed to delete the document',
    successMessage: 'Document successfully deleted',
  })

  return { deleteDocument, returnData, isLoading, isSuccess, isError }
}
